import { get } from 'data/services/apiService';
import { API_URL } from 'data/services/apiConstants';

const BLOCK_AND_LOT_SEARCH_REQUEST = 'BLOCK_AND_LOT_SEARCH_REQUEST';
const BLOCK_AND_LOT_SEARCH_SUCCESS = 'BLOCK_AND_LOT_SEARCH_SUCCESS';
const BLOCK_AND_LOT_SEARCH_ERROR = 'BLOCK_AND_LOT_SEARCH_ERROR';
const BLOCK_AND_LOT_SEARCH_CLEAR = 'BLOCK_AND_LOT_SEARCH_CLEAR';

const initialState = {
	block: null,
	lot: null,
	borough: null,
	addresses: [],
	isLoading: false,
	hasError: false,
	error: null,
};

export const searchAddressesByBlockAndLot = (block, lot, borough) => (dispatch) => {
	if (!block || !lot || !borough) {
		return;
	}

	let url = `${API_URL}/api/search/property/addresses-by-block-lot?block=${block}&lot=${lot}&borough=${borough}`;
	dispatch(blockAndLotSearchRequest(block, lot, borough));
	return get({
		dispatch,
		url,
		onSuccess: (result) => {
			dispatch(blockAndLotSearchSuccess(result));
		},
		onError: (error) => dispatch(blockAndLotSearchError(error)),
	});
};

export const blockAndLotSearchRequest = (block, lot, borough) => ({
	type: BLOCK_AND_LOT_SEARCH_REQUEST,
	payload: {
		block,
		lot,
		borough,
		addresses: [],
		isLoading: true,
		hasError: false,
		error: null,
	},
});

export const blockAndLotSearchSuccess = (data) => ({
	type: BLOCK_AND_LOT_SEARCH_SUCCESS,
	payload: {
		addresses: data.addresses || [],
		isLoading: false,
		hasError: false,
		error: null,
	},
});

export const blockAndLotSearchError = (error) => ({
	type: BLOCK_AND_LOT_SEARCH_ERROR,
	payload: {
		addresses: [],
		isLoading: false,
		hasError: true,
		error: error,
	},
});

export const clearBlockAndLotSearch = () => ({
	type: BLOCK_AND_LOT_SEARCH_CLEAR,
	payload: initialState,
});

const blockAndLotSearchReducer = (state = initialState, action) => {
	switch (action.type) {
		case BLOCK_AND_LOT_SEARCH_REQUEST:
		case BLOCK_AND_LOT_SEARCH_SUCCESS:
		case BLOCK_AND_LOT_SEARCH_ERROR:
		case BLOCK_AND_LOT_SEARCH_CLEAR:
			return {
				...state,
				...action.payload,
			};
		default:
			return state;
	}
};

export default blockAndLotSearchReducer;
